// removed by extract-text-webpack-plugin
module.exports = {"firstDivisor":"_30DoAoNm3na0WkmATHLUai","firstLine":"_34lAoCnQdriGw_xEryyGnu","secondLine":"_3tPflHggPhKyHkMkO4SlUx","thirdLine":"fKc8nHcXfiyScED3yvJrO","spanText":"_3Is9nLXS9NFIjetx1sx4Ux","divider":"_1PVmRNdIE7-3bDznCUeo1g"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Division/style.css
// module id = 1070
// module chunks = 0